<template>
  <div class="container-fluid">
    <div
      class="row header bt-primary justify-content-between align-items-center"
    >
      <div class="col-auto">
        <img
          class="titleimg"
          src="@/assets/acrypro/ambi_logo.png"
          width="100px"
          style="cursor: pointer"
          @click="backhome"
        />
      </div>
      <div class="col-auto">
        <a
          class="text-dark me-3"
          style="text-decoration: none; cursor: pointer"
          @click="contact"
          >お問い合わせ</a
        >
      </div>
    </div>
    <div class="row top-spacer" style="height: 70px"></div>
    <div class="row justify-content-between align-items-center" style="height: 60px">
      <div class="col">
        <img
          class="img-fluid top-logo"
          style="width: 300px"
          src="@/assets/acrypro/logo.svg"
        />
      </div>
    </div>
    <div class="row align-items-center mt-3" style="">
      <div class="col">
        <h5 class="textcolor" style="font-size: 15px">
          ACRY APP アカウントをご利用いただけます
        </h5>
      </div>
    </div>
    <form>
      <div class="row mt-4 justify-content-center">
        <div class="col-auto text-start">
          <h4 class="textcolor text-start" style="font-size: 15px">メールアドレス</h4>
          <input
            type="email"
            class="input border border-1 border-gray rounded mt-1 acry-input"
            v-model="email"
            v-on:keydown.enter="loginAction"
            placeholder="メールアドレス"
          />
          <p v-if="isMailError" class="mt-3 ms-2 text-danger">
            メールアドレスが正しくありません
          </p>
        </div>
        <div class="row mt-3 justify-content-center">
          <div class="col-auto">
            <h4 class="textcolor text-start" style="font-size: 15px">パスワード</h4>
            <input
              type="password"
              class="input border border-1 border-gray rounded acry-input"
              v-model="password"
              v-on:keydown.enter="loginAction"
              placeholder="6文字以上の半角英数字"
            />
            <p v-if="isPasswordError" class="mt-3 text-danger">
              パスワードは6文字以上入力してください
            </p>
          </div>
        </div>
      </div>

      <div class="row justify-content-center mt-4">
        <div class="col-12">
          <button type="button" class="loginbtn acry-background" @click="this.loginAction">
            <h5 class="mt-2 fw-bold">ログイン</h5>
          </button>
        </div>
        <div class="col-12 mt-3">
          <a
            class="textcolor cursor-pointer"
            style="text-decoration: none"
            @click="this.forgetPassword"
            >パスワードを忘れた方はこちら</a
          >
        </div>
        <div class="col-12 mt-2">
          <a
            class="textcolor cursor-pointer"
            @click="this.registAction"
            style="text-decoration: none"
            >新規登録</a
          >
        </div>

        <div class="col-12 my-4 d-flex justify-content-center">
          <div class="line">
          </div>
          <div class="">
            または
          </div>
          <div class="line">
          </div>
        </div>

        <!-- PC: フルワイドのテキストボタン -->
        <div class="col-12 mt-2 social-desktop">
          <button type="button" class="socialloginbtn" @click="googleLoginAction">
            <div class="social-logo">
              <img src="@/assets/logo/google_logo.svg" />
            </div>
            <div class="ms-5 fw-bold">Google でログイン</div>
          </button>
        </div>

        <div class="col-12 mt-3 social-desktop">
          <button type="button" class="socialloginbtn" @click="appleLoginAction">
            <div class="social-logo">
              <img src="@/assets/logo/apple_logo.svg" />
            </div>
            <div class="ms-5 fw-bold">Apple でログイン</div>
          </button>
        </div>

        <!-- スマホ: アイコンのみ横並び -->
        <div class="col-12 mt-2 social-mobile">
          <button
            type="button"
            class="social-icon-btn"
            @click="googleLoginAction"
            aria-label="Googleでログイン"
          >
            <img src="@/assets/logo/google_logo.svg" />
          </button>
          <button
            type="button"
            class="social-icon-btn"
            @click="appleLoginAction"
            aria-label="Appleでログイン"
          >
            <img src="@/assets/logo/apple_logo.svg" />
          </button>
        </div>

        <div class="col-12" style="height: 150px"></div>
      </div>
    </form>
    <Loading v-if="this.$store.state.isLoading" />
    <AlertDialog v-if="this.$store.state.isAlertDialog" />
    <PcAccessDialog v-if="this.$store.state.isShowPcAccessDialog" />
  </div>
</template>

<script>
// @ is an alias to /src
import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/analytics";
import "firebase/functions";
import router from "../router";
import { User } from "@/js/User.js";
import VueCookies from "vue-cookies";
import axios from "axios";
import Loading from "@/components/modal/dialog/Loading.vue";
import AlertDialog from "@/components/acyrpro/modal/dialog/AlertDialog_Ap.vue";
import PcAccessDialog from "@/components/acyrpro/modal/dialog/PcAccessDialog_Ap.vue";
import { Common } from "@/js/common.js";
import { Analytics } from "@/js/Analytics.js";
import { Logger } from '@/js/utils/Logger.js';
import { Device } from '@/js/utils/Device.js';


export default {
  name: "Login",
  head: {
    bodyAttrs: {
      class: "body-class",
    },
  },
  components: {
    Loading,
    AlertDialog,
    PcAccessDialog,
  },
  data() {
    return {
      showError: false,
      errorMessage: "",
      version: "",
      email: "",
      password: "",
      isMailError: false,
      isPasswordError: false,
    };
  },
  async created() {
    let isCheck = VueCookies.get("redirectcheck");
    if (isCheck == "true") {
      VueCookies.set("redirectcheck", "false");
      // storeが初期化されるまで少し待つ
      await this.sleepByPromise(0.1);
      this.$store.commit("showLoading");
      Logger.info("IsRedirect");
      await firebase
        .auth()
        .getRedirectResult()
        .then((result) => {
          Logger.debug(result);
          if( !result.user  ){
            this.$store.commit("hideLoading");
            this.$store.commit(
              "showMessage",
              "ログインに失敗しました"
            );
            return;
          }

          let method = VueCookies.get("method");
          if (!method) {
            method = 'unknown';
          }

          // 初ログイン時はイベント発火
          if( result.additionalUserInfo.isNewUser ){
            Analytics.signUp(method);
          }

          this.afterLoginAction();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.showError = true;
          this.$store.commit("hideLoading");
        });
    }

    // localhostではバージョンファイルの管理はいらないので、
    // それ以外なら実行
    if( location.host.indexOf('localhost') == -1 ){
      let latestVersion = await this.checkVersion();
      this.version = VueCookies.get("apversion");
      VueCookies.set("apversion", latestVersion);
      if (latestVersion && this.version != latestVersion) {
        window.location.reload(true);
      }
    }
  },
  computed: {
    isMobile() {
      return Device.isMobile();
    },
  },
  mounted() {
    this.$store.commit("resetData")
  },
  watch: {
    email() {
      this.isMailError = false;
    },
    password() {
      this.isPasswordError = false;
    },
  },
  methods: {
    async sleepByPromise(sec) {
        return new Promise(resolve => setTimeout(resolve, sec*1000));
    },
    backhome() {
      router.push("/");
    },
    async checkVersion() {
      return new Promise((resolve) => {
        var date = new Date();
        this.version = VueCookies.get("shipversion");
        axios
          .get("/version.txt?rand=" + date.getTime(), {baseURL:""})
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            resolve();
          });
      });
    },
    forgetPassword() {
      router.push("/forgotpassword");
    },

    async appleLoginAction(){
      this.$store.commit("showLoading");

      await firebase.auth().signOut();
      const provider = new firebase.auth.OAuthProvider('apple.com');
      provider.addScope('email');
      provider.addScope('name');

      provider.setCustomParameters({
        locale: 'ja_JP'
      });

      VueCookies.set("redirectcheck", "true");
      VueCookies.set("method", "Apple");
      await firebase.auth().signInWithRedirect(provider);
    },

    async googleLoginAction(){
      this.$store.commit("showLoading");

      await firebase.auth().signOut();
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: "select_account",
      });

      VueCookies.set("redirectcheck", "true");
      VueCookies.set("method", "Google");
      await firebase.auth().signInWithRedirect(provider);
    },

    async loginAction() {
      if (this.password.length < 6) {
        this.isPasswordError = true;
      }
      if (Common.isInValidEmail(this.email)) {
        this.isMailError = true;
      }
      if (this.isPasswordError || this.isMailError) {
        return;
      }

      // バージョン取得
      await firebase.auth().signOut();
      this.$store.commit("showLoading");
      let result = false;
      await firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          if (!firebase.auth().currentUser.emailVerified) {
            this.$store.commit("hideLoading");
            this.$store.commit(
              "showMessage",
              "メールアドレスが認証されていません\nメールボックスに認証メールがないか確認してください"
            );
            return;
          }

          result = true;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.showError = true;

          this.$store.commit("showMessage", this.$common.fbmessageToJp(error));
          this.$store.commit("hideLoading");
        });

      if (!result) return;
      // ここまできている場合はログイン成功
      VueCookies.set("method", "email");
      this.afterLoginAction();
    },

    // ログイン後の処理
    afterLoginAction(){
      // ログイン情報をアナリティクスに設定
      Analytics.setUserId(firebase.auth().currentUser.uid);

      let method = VueCookies.get("method");
      VueCookies.remove("method");
      if (!method) {
        method = 'unknown';
      }

      Analytics.login(method);

      // 再ログイン用のCredentialを取得
      if( method == 'email' ) {
        const credential = firebase.auth.EmailAuthProvider.credential(
          this.email,
          this.password
        );
        User.credential = credential;
      }else{
        User.credential = null;
      }

      // サーバーのメールアドレスとFirebaseのメールアドレスを比較

      const isMobile = this.isMobile;

      // データを取ってきて情報が登録されているか確認
      User.getFBAcryProUserData().then((data) => {
        if (data && "isSendRequest" in data && data.isSendRequest) {
          // 契約書送信済み: ホームへ。ただしモバイルはホーム未対応のためPC案内
          if (isMobile) {
            this.$store.commit("hideLoading");
            this.$store.commit("showPcAccessDialog", async () => {
              await firebase.auth().signOut().catch(() => {});
            });
            return;
          }

          User.getInfo().then((userData) => {

            if (userData.email != firebase.auth().currentUser.email) {
              // 異なる場合はサーバーのデータを更新
              User.registInfo({ email: firebase.auth().currentUser.email })
                .then(() => {
                  this.$store.commit("hideLoading");
                  router.replace('/home');
                })
                .catch((error) => {
                  Logger.debug(error);
                  this.$store.commit("hideLoading");
                  this.$store.commit("showMessage", "エラーが発生しました");
                  return;
                });
            } else {
              this.$store.commit("hideLoading");
              router.replace('/home');
            }
          }).catch(()=>{
            this.$store.commit("hideLoading");
            this.$store.commit("showMessage", "エラーが発生しました");
          });
        } else {
          // 登録画面へ (モバイルはスマホ専用フォームへ)
          this.$store.commit("hideLoading");
          if (isMobile) {
            router.push("/acryappform");
          } else {
            router.push("/acryproform");
          }
        }
      });
    },
    registAction() {
      router.push("/registmail");
    },
    contact() {
      router.push("/contact");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.titleimg {
  /* すべての辺 */
  border-image-slice: 30%;
}
.textcolor {
  color: #000000;
}
.input {
  width: 250px;
  height: 50px;
}
.loginbtn {
  color: white;
  width: 320px;
  height: 62px;
  vertical-align: middle;
  border-radius: 32px;
  border: none;
  font-weight: bold;
}
.loginbtn :hover {
  color: white;
}
.acry-input {
  width: 320px;
  height: 48px;
  padding-left: 10px;
}


.socialloginbtn {
  position: relative;
  color: #1F1F1F;
  background: white;
  width: 320px;
  height: 62px;
  vertical-align: middle;
  border-radius: 32px;
  border: solid 1px #8E918F;
  font-weight: bold;
  font-size: 17px;
}
/* .socialloginbtn :hover {
  color: white;
} */

.social-logo {
  position: absolute;
  top: 10px;
  left: 32px;
}

.line {
  margin: 11px 24px;
  height: 1px;
  width: 124px;
  background-color: #8C9BC6;;
}

/* スマホ用: アイコンのみのソーシャルログイン (PCでは非表示) */
.social-mobile {
  display: none;
}
.social-icon-btn {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
}
.social-icon-btn img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

@media (max-width: 480px) {
  .loginbtn,
  .acry-input,
  .socialloginbtn {
    width: 88vw;
    max-width: 320px;
  }
  .line {
    width: 25vw;
    margin: 11px 12px;
  }
  /* ヘッダーとロゴの間の余白をスマホでは狭く */
  .top-spacer {
    height: 24px !important;
  }
  /* トップのロゴをスマホでは少し小さく */
  .top-logo {
    width: 250px !important;
  }
  /* PC用のテキスト付きボタンを隠し、アイコン横並びを表示 */
  .social-desktop {
    display: none;
  }
  .social-mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 36px;
  }
}
</style>
